import { AssetOwnerService } from 'client/services';
import { getEpsgCode } from 'client/utils/helpers/MapConfig/MapConfig';
import store from 'client/store/store';
import { fetchMyCoverageOnce, setCoverageAssetOwners } from 'client/store/coverageAssetOwnersSlice/coverageAssetOwnersSlice';

const loader = async () => {
    const [
        epsgCode,
        assetOwners
    ] = await Promise.all([
        getEpsgCode(),
        AssetOwnerService.getAllAssetOwnersInMyArea()
    ]);

    store.dispatch(setCoverageAssetOwners(assetOwners.assetOwners));

    // if the coverage already successfully fetched, this will be a no-op
    store.dispatch(fetchMyCoverageOnce());

    return { epsgCode };
};

export default loader;
